'use client';

import Footer from './Footer';
import { useLanguage } from '@/contexts/LanguageContext';

interface FooterLink {
  label: string;
  href: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

interface SocialLink {
  name: string;
  icon: string;
  href: string;
}

const FooterWrapper = () => {
  const { t } = useLanguage();

  const footerSections: FooterSection[] = [
    {
      title: t('footer.navigation'),
      links: [
        { label: t('header.home'), href: "/home" },
        { label: t('header.aboutUs'), href: "/about-us" },
        { label: t('header.whyGoldSilver'), href: "/why-gold-and-silver" },
        { label: t('header.products'), href: "/products" }
      ]
    },
    {
      title: t('footer.services'),
      links: [
        { label: t('header.priceList'), href: "/price-list" },
        { label: t('header.contact'), href: "/contact" },
        { label: t('footer.deliveryPayment'), href: "/delivery-and-payment-terms" }
      ]
    }
  ];

  const socialLinks: SocialLink[] = [
    { name: 'Facebook', icon: 'ShareIcon', href: '#' },
    { name: 'Twitter', icon: 'ShareIcon', href: '#' },
    { name: 'LinkedIn', icon: 'ShareIcon', href: '#' },
    { name: 'Instagram', icon: 'ShareIcon', href: '#' }
  ];

  const contactInfo = {
    phone: '+49 (0) 6359 86762',
    secondaryPhone: '+49 (0) 172 297 30 22',
    email: 'info@golddreams.eu',
    address: 'Peterskopfstr. 2, 67269 Grünstadt, Deutschland'
  };

  return (
    <Footer
      sections={footerSections}
      socialLinks={socialLinks}
      contactInfo={contactInfo}
    />
  );
};

export default FooterWrapper;